module.exports = __webpack_public_path__ + "img/gold-winner-badge.fc03da81.svg";